// isThreeHoursChannel이 true인 파트너만 현재 사이트에 남기고, 나머지는 partners 서브도메인으로 redirect
export default defineNuxtRouteMiddleware(async (to) => {
  if (!to.path.startsWith('/partners/') || !to.params.partner) return

  const { partnersUrl } = useRuntimeConfig().public
  // 이미 partners 서브도메인이면 redirect 루프 방지
  if (!partnersUrl || useRequestURL().host === new URL(partnersUrl).host) return

  await usePartnerLoader(to.params.partner as string)

  const partnerInfo = usePartnerStore().partnerInfo
  if (!partnerInfo || partnerInfo.isThreeHoursChannel) return

  // 서브도메인은 /partners 접두사 없이 /{partner}로 받는다 (기존 routeRules의 `/**` redirect와 동일)
  return navigateTo(`${partnersUrl}${to.fullPath.replace(/^\/partners/, '')}`, { external: true })
})
